"use client";

import { useState, useEffect } from "react";
import { motion } from "framer-motion";

export default function HomePage() {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => setIsMobile(window.innerWidth <= 768);
    checkMobile();
    window.addEventListener("resize", checkMobile);
    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  return (
    <>
      {/* Hero Section */}
      <section
        style={{
          height: "100dvh",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          padding: isMobile ? "0 16px" : "0 40px",
          boxSizing: "border-box",
          overflow: "hidden",
          position: "relative",
        }}
      >
        <img
          src="/DFSG_Logow.png"
          alt="DFSG Logo"
          style={{
            position: "absolute",
            top: isMobile ? "20px" : "40px",
            left: isMobile ? "20px" : "40px",
            height: isMobile ? "56px" : "80px",
            width: "auto",
          }}
        />
        <div style={{ maxWidth: "900px", width: "100%", display: "flex", flexDirection: "column", alignItems: "center" }}>
          <motion.h1
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, ease: "easeOut" }}
            style={{
              fontSize: isMobile ? "2.5rem" : "5.5rem",
              fontWeight: 400,
              color: "#0a0a0a",
              letterSpacing: "-0.04em",
              lineHeight: 1.1,
              textAlign: "center",
              margin: 0,
            }}
          >
            We are a human-centered design studio redesigning the future of work and education
          </motion.h1>
          <motion.a
            href="mailto:hello@dfsgdesign.com"
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, ease: "easeOut", delay: 0.3 }}
            style={{
              display: "inline-block",
              marginTop: isMobile ? "24px" : "36px",
              padding: isMobile ? "12px 24px" : "14px 28px",
              borderRadius: "100px",
              border: "1px solid rgba(0,0,0,0.15)",
              fontSize: isMobile ? "0.95rem" : "1rem",
              fontWeight: 400,
              color: "#0a0a0a",
              textDecoration: "none",
              letterSpacing: "-0.01em",
              transition: "background-color 0.2s ease, border-color 0.2s ease",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = "rgba(0,0,0,0.04)";
              e.currentTarget.style.borderColor = "rgba(0,0,0,0.3)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = "transparent";
              e.currentTarget.style.borderColor = "rgba(0,0,0,0.15)";
            }}
          >
            Let&apos;s work together
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" style={{ display: "inline-block", marginLeft: "8px", verticalAlign: "middle" }}>
              <path d="M7 17L17 7" /><path d="M7 7h10v10" />
            </svg>
          </motion.a>
        </div>
      </section>
    </>
  );
}
